import Vue, { KeepAlive } from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/login" },
  {
    path: "/login",
    name: "LoginIndex",
    meta: { title: "新昌旅游包车驾驶员端" },
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/charter-order",
    name: "CharterOrder",
    meta: { title: "待包车", keepAlive: true },
    component: () => import("@/views/charter-order/index.vue"),
  },
  {
    path: "/charter-record",
    name: "CharterRecord",
    meta: { title: "包车记录", keepAlive: true },
    component: () => import("@/views/charter-record/index.vue"),
  },
  {
    path: "/mine",
    name: "MineIndex",
    meta: { title: "我的" },
    component: () => import("@/views/mine/index.vue"),
  },
  {
    path: "/charter-submit",
    name: "CharterSubmit",
    meta: { title: "包车提交数据" },
    component: () => import("@/views/charter-submit/index.vue"),
  }
];

const router = new VueRouter({
  routes,
  base: "/lybcwx3/",
});
export default router;
